 export default {
    state: {
        user: {
            id: null,
            nome: null,
            email: null,
            cnpj: null,
            tipo: null,
            inadiplente: null,
            sindicato_id: null,
            ativo: null
        }
    },

    getters: {
        /**
         * Retorna o usuário
         * @param state
         * @returns {{image: string, name: string, id: number, email: string}|PublicKeyCredentialUserEntity}
         */
        getUser: (state) => {
            return state.user;
        }
    },

    mutations: {
        /**
         * Seta o usuário
         * @param state
         * @param payload
         */
        setUser: (state, payload) => {
            state.user.id = payload.id;
            state.user.nome = payload.name;
            state.user.email = payload.email;
            state.user.cnpj = payload.cnpj;
            state.user.tipo = payload.tipo;
            state.user.inadiplente = payload.inadiplente;
            state.user.sindicato_id = payload.sindicato_id;
            state.user.ativo = payload.ativo;
        },

        /**
         * Reseta o usuário
         * @param state
         */
        resetUser: (state) => {
            state.user.id = null;
            state.user.nome = null;
            state.user.email = null;
            state.user.cnpj =null;
            state.user.tipo = null;
            state.user.inadiplente = null;
            state.user.sindicato_id = null;
            state.user.ativo = null;
        }
    },

     actions: {
        do_set_user ({commit}, data) {
            commit('setUser', data)
        },

         do_reset_user ({commit}) {
            commit('resetUser')
         }
     }
}
